export default __webpack_public_path__ + "static/prof-desktop-mobile-cd71c887db2ca5e9e11e1dfb41e74241.png";